import { AppService } from './../service/app.service';
import { AuthService } from './../service/auth.service';
import { AuthGuardService } from './../service/auth-guard.service';
import { SidebarService } from './../service/sidebar.service';
import { AccessibilityService } from './../service/accessibility.service';


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//Components
import { LandingComponent } from './landing/landing.component';
import { HelpComponent } from './help/help.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { BallotreviewComponent } from './ballotreview/ballotreview.component';
import { DialogComponent } from './dialog/dialog.component';
import { SettingsComponent } from './settings/settings.component';
import { TopMenuBarComponent } from './top-menu-bar/top-menu-bar.component';
import { RecoveryComponent } from './recovery/recovery.component';
//Services
import { DialogService } from './../service/dialog.service';
import { CandidateService } from './../service/candidate.service';
import { CandidateStatementComponent } from './candidate-statement/candidate-statement.component';
import { NavbarService } from '../service/navbar.service';
import { SuccessPageComponent } from './success-page/success-page.component';
import { NumbertowordsPipe } from '../pipe/numbertowords.pipe';
import { SafeHTMLPipe } from '../pipe/safehtml.pipe';
import { SessionService } from './../service/session.service';
import { VotingpageComponent } from './votingpage/votingpage.component';
import { BallotReviewBtnComponent } from './ballot-review-btn/ballot-review-btn.component';



//import { MenuBarComponent } from './menu-bar/menu-bar.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    TopMenuBarComponent,
    LoginComponent,
    LandingComponent,
    HelpComponent,
    SettingsComponent,
    RecoveryComponent,
    BallotreviewComponent,
    DialogComponent,
    CandidateStatementComponent,
    SidebarComponent,
    BallotReviewBtnComponent,
    SuccessPageComponent,
    NumbertowordsPipe,
    VotingpageComponent,
    SafeHTMLPipe,

  ],
  exports: [LoginComponent],
  providers: [CandidateService, DialogService, AccessibilityService, NavbarService, SidebarService, AuthGuardService, AuthService, SessionService,
    AppService]
})
export class FeaturesModule { }



// WEBPACK FOOTER //
// ./src/app/features/features.module.ts